import { JSX } from 'preact';

type IconProps = { size?: number; class?: string };

export function IconArrow({ size = 16, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" class={className} aria-hidden="true">
      <path d="M3 8h10m0 0L9 4m4 4L9 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconQR({ size = 16, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" class={className} aria-hidden="true">
      <rect x="1" y="1" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.4"/>
      <rect x="10" y="1" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.4"/>
      <rect x="1" y="10" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.4"/>
      <rect x="10.5" y="10.5" width="1.5" height="1.5" fill="currentColor"/>
      <rect x="13.5" y="10.5" width="1.5" height="1.5" fill="currentColor"/>
      <rect x="10.5" y="13.5" width="1.5" height="1.5" fill="currentColor"/>
    </svg>
  );
}

export function IconChevron({ size = 14, dir = 'right', class: className }: IconProps & { dir?: 'right' | 'left' }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      class={className}
      style={{ transform: dir === 'left' ? 'rotate(180deg)' : 'none' }}
      aria-hidden="true"
    >
      <path d="M5 3l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconBack({ size = 20, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" class={className} aria-hidden="true">
      <path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconLock({ size = 12, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="none" class={className} aria-hidden="true">
      <rect x="1.5" y="4.5" width="7" height="5" rx="1" stroke="currentColor" stroke-width="1.2"/>
      <path d="M3 4.5V3a2 2 0 014 0v1.5" stroke="currentColor" stroke-width="1.2"/>
    </svg>
  );
}

export function IconPlus({ size = 16, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" class={className} aria-hidden="true">
      <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  );
}

export function IconReply({ size = 14, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" class={className} aria-hidden="true">
      <path d="M9 3L3 7l6 4M3 7h6a3 3 0 013 3v1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconInfo({ size = 14, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" class={className} aria-hidden="true">
      <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.3"/>
      <path d="M7 6v4M7 4.2v.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    </svg>
  );
}

export function IconClose({ size = 14, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" class={className} aria-hidden="true">
      <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
  );
}

export function IconPencil({ size = 18, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" class={className} aria-hidden="true">
      <path d="M12 3l3 3-8.5 8.5L3 15l.5-3.5L12 3z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconCamera({ size = 18, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" class={className} aria-hidden="true">
      <rect x="1.5" y="4.5" width="15" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M6 4.5l1-1.5h4l1 1.5" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="9" cy="10" r="3" stroke="currentColor" stroke-width="1.5"/>
    </svg>
  );
}

export function IconMic({ size = 18, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" class={className} aria-hidden="true">
      <rect x="6.5" y="2" width="5" height="9" rx="2.5" stroke="currentColor" stroke-width="1.5"/>
      <path d="M3.5 9a5.5 5.5 0 0011 0M9 14.5V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  );
}

export function IconVideo({ size = 18, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" class={className} aria-hidden="true">
      <rect x="1.5" y="4.5" width="10" height="9" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M11.5 8l5-2.5v7L11.5 10z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    </svg>
  );
}

export function IconBell({ size = 20, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" class={className} aria-hidden="true">
      <path d="M4 8a6 6 0 0112 0v3l1.5 2.5H2.5L4 11V8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
      <path d="M7.5 16a2.5 2.5 0 005 0" stroke="currentColor" stroke-width="1.6"/>
    </svg>
  );
}

export function IconMail({ size = 20, class: className }: IconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" class={className} aria-hidden="true">
      <rect x="2" y="4.5" width="16" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M2.5 5.5l7.5 5 7.5-5" stroke="currentColor" stroke-width="1.5"/>
    </svg>
  );
}
